import { useState } from "react"
import { Cross2Icon } from "@radix-ui/react-icons"
import { Dialog, DialogFooter, DialogHeader } from "~/components/ui/dialog"
import { Button } from "~/components/ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "~/components/ui/tooltip"
import type { Packages } from "@prisma/client"

export function LoveObjectSelection({
  open,
  onLoveObjectSelect,
  onClose,
  loveObjects,
  selectedLoveObject,
}: {
  open: boolean
  onLoveObjectSelect: (pkg: Packages, src: string) => void
  selectedLoveObject: Packages | null
  onClose: () => void
  loveObjects: Packages[]
}) {
  return (
    <div className="left-0 right-0 top-full mt-2 z-50 bg-background p-4 rounded-lg shadow-lg border border-border">
      <Dialog open={open} onOpenChange={onClose}>
      <div className="flex justify-end">
        <button
          className="z-20 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none"
          onClick={onClose}
        >
          <Cross2Icon className="h-6 w-6" />
        </button>
    </div>
        <DialogHeader className="relative z-10 mt-3">
          <div className="flex items-center justify-center gap-4">
            <Button variant={"outline"} className="shadow gap-2 cursor-default">
              <p className="bg-primary text-primary-foreground flex items-center text-xs gap-[2px] rounded-lg px-[6px] py-[2px]">
                $5
              </p>
              Love Objects
            </Button>
          </div>
        </DialogHeader>
        <div className="relative flex flex-wrap justify-center gap-x-4 gap-y-4 my-1 mx-4 overflow-y-auto sm:overflow-y-auto sm:max-h-[300px] max-h-[150px]">
          <TooltipProvider delayDuration={100} skipDelayDuration={0} disableHoverableContent={true}>
            {loveObjects.map((loveObject, index) => {
              return (
                <Tooltip key={index}>
                  <TooltipTrigger asChild>
                    <div
                      className="relative group w-16 h-16 sm:w-24 sm:h-24 rounded-lg flex items-center justify-center cursor-pointer"
                      onClick={() => onLoveObjectSelect(loveObject, loveObject.ImageUrl ?? "")}
                    >
                      <img
                        src={loveObject.ImageUrl ?? ""}
                        alt={loveObject.Tag ?? ""}
                        className={`w-16 h-16 sm:w-24 sm:h-24`}
                        loading="lazy"
                      />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="max-w-64 text-center">
                    {loveObject.Description}
                  </TooltipContent>
                </Tooltip>
              );
            })}
          </TooltipProvider>
        </div>
      </Dialog>
    </div>
  )
}
